module.exports = __webpack_public_path__ + "img/home-essential.5148c3fe.png";